// The server answers 409 when the account is already billed through the App
// Store or Google Play; buying here as well would charge the user twice.
export async function alertIfStoreBilled(response) {
	if (response.status !== 409) return false
	const body = await response.json().catch(() => ({}))
	alert(body.error || 'Your subscription is billed through an app store.')
	return true
}
